import { Component, OnInit } from '@angular/core';
import { Localization } from 'src/app/shared/localization';

@Component({
  selector: 'app-banner-pago',
  templateUrl: './banner-pago.component.html',
  styleUrls: ['./banner-pago.component.scss']
})
export class BannerPagoComponent implements OnInit {
  localization: Localization;

  constructor(localization: Localization) {
    this.localization = localization;
  }

  ngOnInit(): void {
  }

}
